import { IMeeting } from 'app/shared/model/meeting.model';
import { FileType } from 'app/shared/model/enumerations/file-type.model';

export interface IAttachment {
  id?: number;
  fileId?: string | null;
  fileName?: string | null;
  filePath?: string | null;
  fileExtension?: string | null;
  fileType?: FileType | null;
  meetings?: IMeeting[] | null;
}

export const defaultValue: Readonly<IAttachment> = {};
